export default __webpack_public_path__ + "static/media/poster-sdg-5.4391850c.png";